<template>
  <div class="login">
    <h2>Welcome</h2>
    <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between down-container">
      <button
        class="btn btn-primary"
        @click="login">
        Login
      </button>
      <router-link
        class="link"
        to="#">Do not login</router-link>
    </div>
  </div>
</template>

<script>
import { API_URL, CLIENT_ID } from '@/config'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import axios from '@/extensions/axios'

export default {
  name: 'LoginPage',

  computed: {
    ...mapGetters('auth', [
      'tokens'
    ])
  },

  created () {
    // Check if inside popup an access_token exists
    if (this.$route.hash.indexOf('#access_token') === 0) {
      const newToken = this.getToken()
      if (!this.tokens || this.tokens.access_token !== newToken.access_token) {
        window.opener.postMessage({
          payload: newToken,
          source: 'login-token'
        }, document.location.origin)
        window.close()
      }
    }
  },

  methods: {
    ...mapMutations('auth', {
      setTokens: 'SET'
    }),

    ...mapActions({
      getMyPermissions: 'permission/my'
    }),

    login () {
      let app = this
      let newWindow = window.open(
        this.getOauthUrl(),
        'Login',
        'height=600, width=450'
      )
      if (newWindow) {
        newWindow.focus()
        window.addEventListener('message', function (e) {
          if (e.data.source !== 'login-token') {
            return
          }
          app.setTokens(e.data.payload)
          axios.reloadHeaders()
          app.getMyPermissions().then(() => {
            if (window.location.pathname === '/login') {
              window.location = '/home'
            }
          })
        })
      }
    },

    getToken () {
      // Extract access_token from returning URL hash
      let tokenData = {}
      this.$route.hash.substring(1).split('&').forEach(param => {
        let paramData = param.split('=')
        if (paramData[0] === 'expires_in') {
          tokenData.expires_in = (new Date()).getTime() + (parseInt(paramData[1]) * 1000)
        } else {
          tokenData[paramData[0]] = paramData[1]
        }
      })
      return tokenData
    },

    getOauthUrl () {
      var path = API_URL + 'auth'
      var client = 'client_id=' + CLIENT_ID
      var redirectUri = 'redirect_uri=' + window.location.origin + window.location.pathname
      var responseType = 'response_type=token'

      return `${path}?${client}&${redirectUri}&${responseType}`
    }
  }
}
</script>

<style lang="scss">
  @import '~@/assets/scss/variables';
  @import '~bootstrap/scss/mixins/breakpoints';
  @import "~bootstrap/scss/functions";
  @import '~bootstrap/scss/variables';

  .login {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
    }
    width: 21.375rem;

    .down-container {
      margin-top: 3.125rem;
    }
  }
</style>
